import { createSelector } from 'reselect';
import moment from 'moment-timezone';

import { ReduxState } from 'ducks';
import { isRequiredGuestType } from 'lib/util/util';
import { selectGuestTypes, selectInitialGuestCount } from 'lib/util/guestSelectUtils';

export interface DateFormValues {
  productInstanceId: string;
  guestCount: Record<string, number>;
  date: string;
}

export const selectInitialDateFormValues = createSelector(
  (state: ReduxState) => state.server.reservation.reservation,
  (state: ReduxState) => state.server.product.product,
  selectGuestTypes,
  selectInitialGuestCount,
  (existingReservation, product, guestTypes, defaultInitialGuestCount) => {
    if (existingReservation) {
      const guestCount: Record<string, number> = {};
      if (existingReservation) {
        for (const guest of existingReservation?.guests || []) {
          const guestTypeKey = guest.guest_type_key;
          if (guestTypes.find((g) => g.key === guestTypeKey)) {
            const currentGuestCount = guestCount[guestTypeKey] || 0;
            guestCount[guestTypeKey] = currentGuestCount + 1;
          }
        }
      }

      for (const guestType of guestTypes) {
        if (!guestCount[guestType.key]) {
          const minPaxRule = product?.booking_widget_settings?.minimum_participant_rules?.find(
            (rule) => rule.unit === guestType.key
          );
          const minimumParticipants = minPaxRule
            ? minPaxRule.minimum_participants ?? 0
            : isRequiredGuestType(guestType)
            ? 1
            : 0;

          if (minimumParticipants > 0) {
            guestCount[guestType.key] = minimumParticipants;
          }
        }
      }

      const timezone = product?.start_timezone || '';
      const date = existingReservation?.start_date_time_utc
        ? moment.tz(existingReservation?.start_date_time_utc, timezone).format('YYYY-MM-DD')
        : '';

      return {
        guestCount,
        date,
      };
    }

    return {
      guestCount: defaultInitialGuestCount,
    };
  }
);
